import seshSto from 'store2'

export default seshSto
